
import file1 from '../../images/document/1.pdf'
import file2 from '../../images/document/2.pdf'
import file3 from '../../images/document/3.pdf'


export const fileList = [
    {name: '中科通量企业宣传册', key: 1},
    {name: 'SmarCo信创智能NAS存储产品介绍', key: 2},
    {name: 'SmarCo智能视频存储产品介绍', key: 3}
]

export const fileMap = {
    1: file1,
    2: file2,
    3: file3
}